import request from '@/utils/request'

/** 销售用户下拉（OFFICE/ADMIN） */
export function getSalesUserList() {
  return request({
    url: '/api/user/sales-list',
    method: 'get'
  })
}

/** 项目经理下拉：仅角色为 PM 的用户（调用方须为 OFFICE/ADMIN/SALES） */
export function getProjectManagerPickerList() {
  return request({
    url: '/api/user/project-manager-picker',
    method: 'get'
  })
}

export function getUserMailProfile() {
  return request({
    url: '/api/user/mail-profile',
    method: 'get'
  })
}

export function saveUserMailProfile(data) {
  return request({
    url: '/api/user/mail-profile',
    method: 'put',
    data
  })
}
